module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "view-coaches-container"
    }
  }, [_c('div', {
    attrs: {
      "id": "view-coaches"
    }
  }, [_c('div', {
    staticClass: "container is-fluid"
  }, [_c('div', {
    staticClass: "columns coach-toolbar"
  }, [_c('div', {
    staticClass: "column is-8"
  }, [_c('p', {
    staticClass: "control has-icon search-container"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchText),
      expression: "searchText"
    }],
    staticClass: "input is-medium",
    attrs: {
      "type": "text",
      "placeholder": "Procurar Coches"
    },
    domProps: {
      "value": (_vm.searchText)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchText = $event.target.value
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-search"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "column is-2"
  }, [_c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "select is-medium is-fullwidth"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedState),
      expression: "selectedState"
    }],
    class: {
      'gray-select': _vm.selectedState === 0
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedState = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    staticClass: "gray-select",
    domProps: {
      "value": 0
    }
  }, [_vm._v("Estados")]), _vm._v(" "), _vm._l((_vm.states), function(state) {
    return _c('option', {
      staticClass: "black-select",
      domProps: {
        "value": state.id
      }
    }, [_vm._v(_vm._s(state.name))])
  })], 2)])])]), _vm._v(" "), _c('div', {
    staticClass: "column is-2"
  }, [_c('coach-new')], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "container is-fluid"
  }, [_c('div', {
    staticClass: "flexbox-grid"
  }, _vm._l((_vm.filteredCoaches), function(coach) {
    return _c('coach-card', {
      attrs: {
        "coach": coach
      }
    })
  }))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2a09f9ba!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Coach/index.vue
// module id = 308
// module chunks = 1